import {
  combineReducers,
  configureStore,
  createAction,
} from '@reduxjs/toolkit';
import adminCampaigns from 'features/admin-campaigns/slice';
import monitoringCommandCenter from 'features/admin-monitoring/command-center/slice';
import monitoringJira from 'features/admin-monitoring/config/jira/slice';
import monitoringConfig from 'features/admin-monitoring/config/slice';
import monitoringDependencies from 'features/admin-monitoring/dependencies/slice';
import monitoringDirectory from 'features/admin-monitoring/directory/slice';
import monitoringRuns from 'features/admin-monitoring/runs/slice';
import monitoringViolations from 'features/admin-monitoring/violations/slice';
import adminUserManagement from 'features/admin-user-management/slice';
import advertiserById from 'features/advertiser/slice';
import advertiser from 'features/advertisers/slice';
import aiResponses from 'features/ai-responses/slice';
import audiences from 'features/audiences/slice';
import automatedNoteSchedules from 'features/automated-note-schedules/slice';
import campaignById from 'features/campaign/slice';
import campaigns from 'features/campaigns/slice';
import client from 'features/client/slice';
import error from 'features/error/slice';
import invoice from 'features/invoice/slice';
import notification from 'features/notification/slice';
import { personasApi } from 'features/persona/api';
import product from 'features/product/slice';
import promptManagement from 'features/prompt-management/slice';
import advertiserReports from 'features/reports/advertisers/slice';
import campaignReports from 'features/reports/campaigns/slice';
import clientReports from 'features/reports/clients/slice';
import user from 'features/user/slice';

export const resetStore = createAction<void>('store/reset');

const combinedReducers = combineReducers({
  advertiser,
  advertiserById,
  advertiserReports,
  aiResponses,
  audiences,
  campaigns,
  campaignById,
  campaignReports,
  client,
  clientReports,
  error,
  automatedNoteSchedules,
  invoice,
  monitoringCommandCenter,
  monitoringConfig,
  monitoringJira,
  monitoringDependencies,
  monitoringDirectory,
  monitoringRuns,
  monitoringViolations,
  notification,
  product,
  promptManagement,
  user,
  adminUserManagement,
  adminCampaigns,
  [personasApi.reducerPath]: personasApi.reducer,
});

const resettableCombinedReducers: typeof combinedReducers = (state, action) => {
  if (resetStore.match(action)) {
    return combinedReducers(undefined, action);
  }

  return combinedReducers(state, action);
};

export const store = configureStore({
  reducer: resettableCombinedReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(personasApi.middleware),
});
